const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchInterviewQuestions = async (application_id, vacancy_title) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/api/v1/chat/interview-questions?token=${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      vacancy_title: vacancy_title,
      app_id: application_id
    }),
  });
  return response.json();
};

export const sendInterviewConclusion = async (interviewData, vacancyTitle) => {
  const token = localStorage.getItem('token');
  const body = {
    interview: interviewData,
    vacancy_title: vacancyTitle
  };
  const response = await fetch(`${API_BASE_URL}/api/v1/chat/interview-conclusion?token=${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  return response.json();
};

export const fetchTextToSpeech = async (text) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/api/v1/openai/text-to-speech?token=${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch text-to-speech');
  }

  const blob = await response.blob();
  return blob;
};

export const fetchCandidateData = async (talent_uuid, application_id, token) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/talent/${talent_uuid}/data?app_id=${application_id}&token=${token}`, {
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch candidate data');
  }

  const result = await response.json();
  return result.data;
};

export const fetchInterviews = async (talent_uuid) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/api/v1/chat/${talent_uuid}/interviews?token=${token}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch interviews');
  }

  const result = await response.json();
  return result;
};

export const storeInterviewData = async (talent_uuid, interviewData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/api/v1/chat/interview-store/${talent_uuid}?token=${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(interviewData),
  });

  if (!response.ok) {
    throw new Error('Failed to store interview data');
  }

  return response.json();
};

export const fetchInterviewData = async (interview_uuid, talent_uuid) => {
  const token = localStorage.getItem('token');
  console.log(interview_uuid);
  const response = await fetch(`${API_BASE_URL}/api/v1/talent/interview/${interview_uuid}?talent_uuid=${talent_uuid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch interview data');
  }

  const result = await response.json();
  return result.data;
};